// Import the necessary components
import VerofreshRecord from './VerofreshRecord'
class AuditedResourceRecord extends VerofreshRecord {
  static get endpoint () { return 'audit-log/audited-resources' }
}

export default AuditedResourceRecord
